import React, { useState, useEffect } from "react";
import LogoJibuness from "../../images/logo-jibuness.png";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard,
} from "../../components/Component";
import { Form, Spinner, Alert } from "reactstrap";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorVal, setError] = useState("");

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    const htmlElement = document.documentElement;
    const bodyElement = document.body;
    const authBg = "#345C74";

    htmlElement.style.setProperty("background-color", authBg, "important");
    htmlElement.style.minHeight = "100vh";

    bodyElement.style.setProperty("background-color", authBg, "important");
    bodyElement.style.minHeight = "100vh";

    return () => {
      htmlElement.style.removeProperty("background-color");
      htmlElement.style.minHeight = "";

      bodyElement.style.removeProperty("background-color");
      bodyElement.style.minHeight = "";
    };
  }, []);

  const onFormSubmit = async (formData) => {
    setLoading(true);
    setError("");
    try {
      // Branchement API : await api.requestPasswordReset(formData.email)
      await new Promise((r) => setTimeout(r, 700));
      setSuccess(true);
    } catch (err) {
      setError(err.message || "Une erreur est survenue. Réessayez plus tard.");
    } finally {
      setLoading(false);
    }
  };

  const loginPath = `${process.env.PUBLIC_URL}/auth-login`;

  return (
    <React.Fragment>
      <Head title="Mot de passe oublié" />
      <div
        style={{
          minHeight: "100vh",
          position: "relative",
          width: "100%",
        }}
      >
        <PageContainer transparent={true}>
          <Block className="nk-block-middle nk-auth-body  wide-xs">
            <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
              <div className="brand-logo text-center pb-4 mb-0">
                <Link to={`${process.env.PUBLIC_URL}/`} className="logo-link">
                  <img
                    className="logo-img logo-img-lg"
                    src={LogoJibuness}
                    alt="Jibuness"
                    style={{
                      width: "min(85vw, 160px)",
                      maxWidth: "100%",
                      maxHeight: "min(28vh, 100px)",
                      height: "auto",
                      objectFit: "contain",
                    }}
                  />
                </Link>
              </div>
              <BlockHead>
                <BlockContent className="text-center">
                  <BlockTitle tag="h4" className="text-center">
                    Mot de passe oublié
                  </BlockTitle>
                  <BlockDes className="text-center">
                    <p>
                      Indiquez l’adresse email de votre compte HSE. Si elle est reconnue, vous
                      pourrez définir un nouveau mot de passe (selon la configuration du service).
                    </p>
                  </BlockDes>
                </BlockContent>
              </BlockHead>

              {success ? (
                <Alert color="success" className="alert-icon">
                  <Icon name="check-circle" />
                  <span>
                    Si cette adresse correspond à un compte, suivez les instructions reçues par
                    email. Pensez à vérifier vos courriers indésirables.
                  </span>
                </Alert>
              ) : (
                <>
                  {errorVal && (
                    <div className="mb-3">
                      <Alert color="danger" className="alert-icon">
                        <Icon name="alert-circle" /> {errorVal}
                      </Alert>
                    </div>
                  )}
                  <Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
                    <div className="form-group">
                      <div className="form-label-group">
                        <label className="form-label" htmlFor="forgot-email">
                          Email
                        </label>
                      </div>
                      <div className="form-control-wrap">
                        <input
                          type="email"
                          id="forgot-email"
                          name="email"
                          ref={register({
                            required: "Ce champ est requis",
                            pattern: {
                              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                              message: "Email invalide",
                            },
                          })}
                          placeholder="Entrez votre adresse email"
                          className="form-control-lg form-control"
                          autoComplete="email"
                          disabled={loading}
                        />
                        {errors.email && (
                          <span className="invalid">{errors.email.message}</span>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <Button
                        color="primary"
                        size="lg"
                        className="btn-block"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? <Spinner size="sm" color="light" className="me-2" /> : null}
                        {loading ? "Envoi…" : "Envoyer le lien"}
                      </Button>
                    </div>
                  </Form>
                </>
              )}

              <div className="form-note-s2 text-center pt-4">
                <Link to={loginPath}>
                  <strong>Retour à la connexion</strong>
                </Link>
              </div>
            </PreviewCard>
          </Block>
          <AuthFooter />
        </PageContainer>
      </div>
    </React.Fragment>
  );
};

export default ForgotPassword;
